/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-inferrable-types */
import { Injectable } from '@angular/core';
import { Inject, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppService } from '../api.service';
import { WindowService } from '../services/window.service';
import { ProjectsService } from './project.service';
import { LocalStorageService } from './localstorage.service';
import { CartService } from './cart.service';
import { SaveIdeaService } from './save-idea.service';
@Injectable({
  providedIn: 'root'
})
export class QuickViewPopupService {
  displayQuickview = false;
  productDetail!:any;
  selectedProductIndex!: number;
  activePos!: number;
  tagged_product: any;
  isSelctedProductLoading!: boolean;
  project_id!: any;
  image_list: any;
  selectedQuantity: any;
  areaSqft: any;
  boxCount!: number;
  total_Sqft_amount: any;
  max_value_qty!: number;
  isError!: boolean;
  activeProductIndex: number=0;
  action_complete!: boolean;
  totalamount:any;
  constructor(@Inject(PLATFORM_ID) private platformId: any, private window: WindowService, private _actRouter: ActivatedRoute, public _as: AppService, public _router: Router,
  public _cart: CartService,private _project:ProjectsService,private localStorageService: LocalStorageService,){
  }
  openQuickview(prod: any, pi: number) {
    this.productDetail = {}
    this.selectedProductIndex = pi;
    this.activePos = pi;
    this.tagged_product = prod;
    this.isSelctedProductLoading = true;
    this.displayQuickview = true;
    let slug:string;
    if(!prod.slug_name){
      slug = prod.slug
    }else{
      slug = prod.slug_name
    }
    const url = this._as.api_base_url + "product/getPro/" + slug + "/?project=" + this.project_id + "&form_type='search'";
    this._as.getRequest(url, true)
      .subscribe((res: any) => {
        this.productDetail = res.product_detail;
        this.productDetail.slug_name = this.productDetail.slug;
        this.image_list = res.product_detail.image_list;
        this.selectedQuantity = this.productDetail.quantity;
        // this.isSelctedProductLoading = false;
        if (this.productDetail.calculation_type == 'sqft_wise') {
          this.areaSqft = this.productDetail.covered_area_par_box.toFixed(2)
          this.boxCount = 1;
          this.total_Sqft_amount = (this.productDetail.par_box_amount).toFixed(2);
          this.max_value_qty = 500;
        } else if (this.productDetail.calculation_type == 'sheet_wise') {
          this.total_Sqft_amount = (this.productDetail.par_box_amount).toFixed(2);
        } else if (this.productDetail.calculation_type == 'meter_wise') {
          this.totalamount = (this.productDetail.product_calculation.per_roll_amount).toFixed(2);
        } else {
          this.max_value_qty = 20;
        }
        if (this._as?.isUserLoggedIn) {
          this.getViewUpdate(prod.id);
        
        }
      },
        (err: any) => {
          if (err) {
            this.isError = true;
            this.isSelctedProductLoading = false;
          }
        });
  }
  getViewUpdate(product_id: number) {
    const url = this._as.api_base_url + 'afterbricks/view/';
    const data = {
      'product': product_id,
      'view': true
    };
    this._as.postRequest(url, data, true)
      .subscribe();
  }

  isObjectEmpty(object: any) {
    if (object && Object.keys(object).length) {
      return true
    } else {
      return false
    }
  }
  onHideQuickPopup(){
    this.activeProductIndex = 0
  }
  selectImg(index: number) {
    if(this.productDetail?.image_list?.length){
      this.activeProductIndex = index;
    }else{
      this.activeProductIndex = 0;
    }
   
  }
  nextimg() {
    this.activeProductIndex = this.activeProductIndex + 1
  }
  previmg() {
    this.activeProductIndex = this.activeProductIndex - 1
  }

  boxWiseCalculat() {
    this.areaSqft = Number((this.productDetail.covered_area_par_box * this.selectedQuantity).toFixed(2))
    this.total_Sqft_amount = this.productDetail.par_box_amount * this.selectedQuantity;
  }
  sheetWiseCalculat() {
    this.total_Sqft_amount = this.productDetail.par_box_amount * this.selectedQuantity;
  }
  increaseQty() {
    if (this.productDetail.calculation_type == "sqft_wise") {
      if (this.selectedQuantity < 5000) {
        this.selectedQuantity = Number(this.selectedQuantity) + 1;
        this.boxWiseCalculat()
        return
      }
    } else if (this.productDetail.calculation_type == "sheet_wise") {
      if (this.selectedQuantity < 5000) {
        this.selectedQuantity = Number(this.selectedQuantity) + 1;
        this.sheetWiseCalculat()
        return
      }
    } else if (this.productDetail.calculation_type == "meter_wise") {
      if (this.selectedQuantity < 50) {
        this.selectedQuantity = Number(this.selectedQuantity) + 1;
        this.totalamount = this.productDetail.product_calculation.per_roll_amount  * this.selectedQuantity;
    
        return
      }
    }else {
      if (this.selectedQuantity < 20) {
        this.selectedQuantity = this.selectedQuantity + 1;
      }
    }
  }
  decreaseQty() {
    if (this.selectedQuantity > 1) {
      this.selectedQuantity = this.selectedQuantity - 1;
      if (this.productDetail.calculation_type == "sqft_wise") {
        this.boxWiseCalculat()
      } else if (this.productDetail.calculation_type == "sheet_wise") {
        this.sheetWiseCalculat()
      }else if (this.productDetail.calculation_type == "meter_wise") {
        this.totalamount = this.productDetail.product_calculation.per_roll_amount  * this.selectedQuantity;
      }
    }
  }
  addQty() {
    if (this.productDetail.calculation_type == "sqft_wise") {
      if (this.selectedQuantity >= 5000) {
        this.selectedQuantity = 5000;
      }
      this.boxWiseCalculat()
    } else if (this.productDetail.calculation_type == "sheet_wise") {
      if (this.selectedQuantity >= 5000) {
        this.selectedQuantity = 5000;
      }
      this.sheetWiseCalculat()
    }else if (this.productDetail.calculation_type == "meter_wise") {
      if (this.selectedQuantity >= 50) {
        this.selectedQuantity = 20;
      }
      this.totalamount = this.productDetail.product_calculation.per_roll_amount  * this.selectedQuantity;} 
      else {
      if (this.selectedQuantity >= 20) {
        this.selectedQuantity = 20
        return
      }
    }
  }

  areaWiseCalculat() {
    const numberToString = (((Number(this.areaSqft) / (this.productDetail.covered_area_par_box)).toFixed(2)).toString()).split('.');
    const f_number = numberToString[0];
    const s_namber = numberToString[1];
    if (Number(s_namber) >= 0) {
      this.selectedQuantity = Number(f_number) + 1
    } else {
      this.selectedQuantity = Number(f_number)
    }
    this.total_Sqft_amount = this.productDetail.par_box_amount * this.selectedQuantity;
  }


  addToCart(prod?: any) {
    if (!this._as.isUserLoggedIn) {
      this._router.navigate([], {
        relativeTo: this._actRouter, queryParams: { activeProdId: this.productDetail.id, isAddCart: true, qty: this.selectedQuantity },
        queryParamsHandling: 'merge',
        replaceUrl: true
      });
      setTimeout(() => {
        this._as.onLoginPage();
      }, 200);
      // this._as.isDisplayLogin = true;
      return
    }
    // this.isSelectProduct = true;
    if (!this.project_id) {
      this.project_id = this._project.selectedProject.id;
    }
    this._cart.addToMyList(prod.id, this.selectedQuantity, this.project_id).then((res: any) => {
      this.displayQuickview = false;
  
      // for updateproduct status
      // this.productList[this.selectedProductIndex].is_addtocart = true;
      this.localStorageService.removeItem('redirectTo')
      let user_info:any;
      try{
        user_info = JSON.parse(this.localStorageService.getItem('user_info') || "");
      }catch{
        user_info = null
      }
      this._project.checkCart();
      const directSearch = {
        isDirectSearch: true,
        is_address: false,
        projectInfo: {
          id: res.project_id,
          step: 1,
          isSpaceSelected: user_info?.directSearch?.projectInfo?.isSpaceSelected
        }
      }
      // if (this.isAddCart) {
      //   this._router.navigate([], {
      //     relativeTo: this._actRouter, queryParams: { isAddCart: null, },
      //     queryParamsHandling: 'merge',
      //     replaceUrl: true
      //   });
      // }
      this._as.user_info.directSearch = directSearch;
      user_info.directSearch = directSearch;
      this.localStorageService.setItem('user_info', JSON.stringify(user_info));
      this.project_id = res.project_id;
      this.displayNotifyMessage();
      // this.checkProduct_data(this.slug_name)
    }).catch((err: any) => {
      console.log(err);
    })

  }

  displayNotifyMessage() {
    this.action_complete = true;
    setTimeout(() => {
      this.action_complete = false
    }, 1200);
  }
}
